/**
 * @generated SignedSource<<d04623d72f7c3efaed0fdd5f53904661>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
import { FragmentRefs } from "relay-runtime";
export type BookingHeaderFragment_booking$data = {
  readonly status?: BookingStatus;
  readonly " $fragmentType": "BookingHeaderFragment_booking";
};
export type BookingHeaderFragment_booking$key = {
  readonly " $data"?: BookingHeaderFragment_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingHeaderFragment_booking">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingHeaderFragment_booking",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "LessonBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "d6d0a672a91d801eb789c6d659417cf4";

export default node;
